// GES-126 ruling 3 — over-committed order flag. Everything here READS the server's derived fields
// (stock_short, stock_short_qty, stock_physical_at_node, stock_committed_ahead); nothing is computed in the browser.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatQty } from '../../utils/format';

import { Emo } from '../../shell/EmojiIcons';
const fmt = (v) => formatQty(Number(v) || 0, 2);   // GES-406: separators from Settings ▸ Formatting

// Amber (warn) token pair = the page's "needs attention, nothing is broken" tone; red stays reserved for Late/Overdue.
export function StockShortBadge({ order, size = 'sm', title }) {
  const { t } = useTranslation('sales');
  if (!order || order.stock_short !== true) return null;
  return (
    <span title={title || t('stockShort.badgeTitle', { short: fmt(order.stock_short_qty) })}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 3, background: 'var(--st-warn-bg)', color: 'var(--st-warn)', padding: '2px 9px', borderRadius: 9999,
               fontSize: size === 'sm' ? 10 : 11, fontWeight: 700, whiteSpace: 'nowrap' }}><Emo name="warn" size={12} />{t('stockShort.badge')}</span>
  );
}

// 'Stock on hand X; committed to older orders Y; short Z' for ONE line.
export function StockShortNote({ line, style }) {
  const { t } = useTranslation('sales');
  if (!line || line.stock_short !== true) return null;
  return (
    <div style={{ fontSize: 11, color: 'var(--st-warn)', marginTop: 2, ...style }}>
      {t('stockShort.hint', { onHand: fmt(line.stock_physical_at_node), ahead: fmt(line.stock_committed_ahead), short: fmt(line.stock_short_qty) })}
    </div>
  );
}
